window.addEventListener("load", function() {
  var formElemSection = document.querySelector('.microsoft-edge-signup-form'),
    formElemHeight = formElemSection ? formElemSection.offsetHeight : 0;

  // load recaptcha JS after page load on doc click
  if (formElemHeight) {
    document.addEventListener('click', loadRecaptchaForForm);
  }

  function loadRecaptchaForForm() {
    if (typeof grecaptcha === 'undefined') {
      var scriptElm = document.createElement('script');
      scriptElm.setAttribute('id', 'recaptcha-js');
      scriptElm.setAttribute('type', 'text/javascript');
      scriptElm.setAttribute('src', 'https://www.google.com/recaptcha/api.js?ver=1.0');
      scriptElm.setAttribute('defer', 'defer');
      document.body.appendChild(scriptElm);
    }
  }
});

var csrf_token,
  railsHost = "https://" + window.location.hostname,
  gaLoadedVal = true,
  mainCtaBtnLinks = document.querySelectorAll(".custom-scroll-btn"),
  signUpFormObj = {}; 

signUpFormObj.formObj = document.getElementById("signin_signup_form");
signUpFormObj.signOn = document.getElementById("google-sign-on-btn");
signUpFormObj.nameField = document.getElementById("user_full_name");
signUpFormObj.emailField = document.getElementById("user_email_login");
signUpFormObj.passwordField = document.getElementById("user_password");
signUpFormObj.tncField = document.getElementById("tnc_checkbox");
signUpFormObj.utf_no = document.getElementById("utf_no");
signUpFormObj.microsoft_edge = document.getElementById("user_page_source_name");
signUpFormObj.promotion_page = document.getElementById("user_page_source");
signUpFormObj.gaLoaded = document.getElementById("gaLoaded");
signUpFormObj.forgotPassword = document.getElementById("fp_signups");
signUpFormObj.submitBtn = document.getElementById("user_submit");

var currentPageUrl = window.location.href,
  previousPageUrl = (document.referrer !== '') ? document.referrer : 'organic',
  gauth_utm_campaigncode = bsLib.getParameterByName("utm_campaigncode") ? bsLib.getParameterByName("utm_campaigncode") : '';

//Add google sign on base64 encode
signUpFormObj.signOn.setAttribute(
  "href",
  signUpFormObj.signOn.getAttribute("href") +
    window.btoa(
      '{"microsoft_edge":"true","referrer_url":"' + currentPageUrl + '", ' +
      '"utm_campaigncode":"' + gauth_utm_campaigncode + '",' +        
      '"primary_product":"' + pageProductName + '",' +
      '"page_url":"' + currentPageUrl + '",' +
      '"previous_page_url":"' + previousPageUrl + '"}'
    )
);

// set clientID to false if ga is not present
var google_analytics = window[window['GoogleAnalyticsObject'] || 'ga'];
if (typeof google_analytics !== 'function') {
  clientId = 'false';
  signUpFormObj.gaLoaded.value = 'false';
  gaLoadedVal = false;
}

var signUpForm = (function(csrfToken, signUpFormObj) {
  return {
    init: init,
    resetForm: resetForm,
    validateFields: _validateFields,
    showError: _showError,
    setCsrfToken: setCsrfToken
  };

  function init(isSignUpForm) {
    var action = signUpFormObj.formObj.getAttribute("action"),
      form_data = {
        utf8: signUpFormObj.utf_no.value,
        page_source_name: signUpFormObj.microsoft_edge.value,
        page_source: signUpFormObj.promotion_page.value,
        authenticity_token: csrfToken,
        gaLoaded: signUpFormObj.gaLoaded.value,
        gaCID: clientId,
        ga_cid: bsLib.GAClientID(),
        utm_campaigncode: document.querySelector('[name="sfdc_utm_campaigncode"]').value.trim(),
        additional_notes: document.querySelector('[name="additional_notes"]').value.trim(),
        primary_product: document.querySelector('[name="primary_product"]').value.trim(),
        secondary_product: document.querySelector('[name="secondary_product"]').value.trim(),
        page_url: currentPageUrl,
        previous_page_url: previousPageUrl,
      };

    if (isSignUpForm) {
      return new Promise(function(resolve, reject) {
        if (grecaptcha === undefined) {
          reject();
        }

        var grecaptchaResponse = grecaptcha.getResponse();
        if (!grecaptchaResponse) {
          reject();
        }

        form_data.terms_and_conditions = signUpFormObj.tncField.value;
        form_data["g-recaptcha-response"] = grecaptchaResponse;
        form_data.user = {
          full_name: signUpFormObj.nameField.value.trim(),
          email: signUpFormObj.emailField.value.trim(),
          password: signUpFormObj.passwordField.value,
          group_attributes: {
            name: ""
          }
        };
        form_data["ga_cid"] = bsLib.GAClientID();

        //sign up form
        // xhr request for sending form data
        bsLib.ajax(
          "POST",
          railsHost + action,
          JSON.stringify(form_data),
          false,
          //Form Header
          {
            "X-CSRF-Token": csrfToken,
            accept: "application/json",
            "content-type": "application/json; charset=utf-8" // Setting content type.
          },
          function(data) {
            //success
            var response = bsLib.JSONParse(data.response);
            // send ga goal event on submit
            if (gaLoadedVal) {
              ga(bsGaDomain + '.send', 'event', {eventCategory: "Microsoft Edge Form", eventAction: "CtaClick", eventLabel: capitalizeLabelName(signUpFormObj.submitBtn.value), eventValue: 0, hitCallback: null});
            }

            //linkedin pixel
            if (window.lintrk !== undefined) {
              window.lintrk('track', { conversion_id: 9342745 });
            }
            
            if (response.success === true) {
              if (
                typeof response.redirect === "string" ||
                typeof response.redirect_to === "string"
              ) {
                window.location = response.redirect || response.redirect_to;
              } else {
                window.location = generate_url("/dashboard", "live");
              }
            }
            resolve();
          },
          function(data) {
            //error
            var responseJson = bsLib.JSONParse(data.response),
              namerError = document.getElementById("name-error"),
              emailError = document.getElementById("email-error"),
              passwordError = document.getElementById("password-error");

            if (responseJson["full_name"] !== undefined) {
              _showError(
                signUpFormObj.nameField,
                namerError,
                "name-error",
                responseJson["full_name"]
              );
            }

            if (responseJson["email"] !== undefined) {
              _showError(
                signUpFormObj.emailField,
                emailError,
                "email-error",
                responseJson["email"]
              );
            }

            if (responseJson["password"] !== undefined) {
              _showError(
                signUpFormObj.passwordField,
                passwordError,
                "password-error",
                responseJson["password"]
              );
            }

            if (responseJson["error"] !== undefined) {
              if (
                responseJson["error"] ===
                "Please verify your account to continue."
              ) {
                window.location.href = generate_url(
                  "/confirmation",
                  "accounts"
                );
              } else {
                _showError(
                  signUpFormObj.passwordField,
                  passwordError,
                  "password-error",
                  Messages.signUpErrors.invalidPassword
                );
              }
            }

            reject();
          },
          true
        );

        grecaptcha.reset();
      });
    } else {
      form_data.user = {
        login: signUpFormObj.emailField.value.trim(),
        password: signUpFormObj.passwordField.value
      };

      //sign in form
      // xhr request for sending form data
      bsLib.ajax(
        "POST",
        railsHost + action,
        JSON.stringify(form_data),
        false,
        //Form Header
        {
          "X-CSRF-Token": csrfToken,
          accept: "application/json",
          "content-type": "application/json; charset=utf-8" // Setting content type.
        },
        function(data) {
          //success
          var response = bsLib.JSONParse(data.response);
          // send ga goal event on submit
          if (gaLoadedVal) {
            ga(bsGaDomain + '.send', 'event', {eventCategory: "Microsoft Edge Form", eventAction: "CtaClick", eventLabel: capitalizeLabelName(signUpFormObj.submitBtn.value), eventValue: 0, hitCallback: null});
          }

          if (response.success === true) {
            if (
              typeof response.redirect === "string" ||
              typeof response.redirect_to === "string"
            ) {
              window.location = response.redirect || response.redirect_to;
            } else {
              window.location = generate_url("/dashboard", "live");
            }
          }
        },
        function(data) {
          //error
          var responseJson = bsLib.JSONParse(data.response),
            emailError = document.getElementById("email-error"),
            passwordError = document.getElementById("password-error");

          if (responseJson["email"] !== undefined) {
            _showError(
              signUpFormObj.emailField,
              emailError,
              "email-error",
              responseJson["email"]
            );
          }

          if (responseJson["password"] !== undefined) {
            _showError(
              signUpFormObj.passwordField,
              passwordError,
              "password-error",
              responseJson["password"]
            );
          }

          //Locked condition
          if (
            responseJson["locked"] !== undefined ||
            (typeof responseJson["attempts_left"] !== undefined &&
              responseJson["attempts_left"] <= 2)
          ) {
            new bsAlert({
              alertType: "error",
              timeout: false,
              text: responseJson["error"]
            });

            if (responseJson["locked"] !== undefined) {
              return;
            }
          }

          if (responseJson["error"] !== undefined) {
            if (
              responseJson["error"] ===
              "Please verify your account to continue."
            ) {
              window.location.href = generate_url("/confirmation", "accounts");
            } else {
              _showError(
                signUpFormObj.passwordField,
                passwordError,
                "password-error",
                Messages.signUpErrors.invalidPassword
              );
            }
          }
        },
        true
      );
    }
  }

  function setCsrfToken() {
    // XHR request for user token
    if (!csrf_token) {
      bsLib.ajax(
        "GET",
        railsHost + "/user/token.json",
        {},
        false,
        {},
        // Success message for user token.
        function(data) {
          var dataRequest = bsLib.JSONParse(data.response),
            authenticityToken = document.querySelectorAll(
              'input[name="authenticity_token"]'
            );

          for (var i = 0; i < authenticityToken.length; i++) {
            authenticityToken[i].value = dataRequest.csrf_token;
          }
          csrfToken = dataRequest.csrf_token;
          csrf_token = csrfToken;
        },
        // Custom Error message for user token.
        function() {
          return Messages.salesAndSupportPage.invalidUserToken;
        }
      );
    } else if (!csrfToken) {
      csrfToken = csrf_token;
    }
  }

  function _validateFields() {
    var formValid = true,
      action = signUpFormObj.formObj.getAttribute("action"),
      mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,8})+$/,
      namerError = document.getElementById("name-error"),
      emailError = document.getElementById("email-error"),
      passwordError = document.getElementById("password-error"),
      emailFieldVal = signUpFormObj.emailField.value.trim();

    //clear error if exists
    signUpFormObj.emailField.classList.remove("error-border");
    signUpFormObj.emailField.removeAttribute('aria-describedby');
    if (emailError) {
      emailError.remove();
    }

    //set csrf token
    setCsrfToken();

    //email
    if ( emailFieldVal == "" || !emailFieldVal.match(mailformat)) {
      var domain = emailFieldVal.substring(emailFieldVal.lastIndexOf("@") +1);

      if ( emailFieldVal.indexOf('@') === -1 
      || emailFieldVal.indexOf('.') === -1 
      || emailFieldVal.indexOf('..') !== -1 
      || bsLib.emailContainsNonLatinCharacters(emailFieldVal) 
      || !(emailFieldVal.indexOf('+') > -1 && (domain == 'browserstack.com' || domain == 'percy.io'))) {
        formValid = _showError(
          signUpFormObj.emailField,
          emailError,
          "email-error",
          Messages.emailValidationErrors.invalidEmail
        );
      }
    }

    //password
    if (signUpFormObj.passwordField.value.length < 6) {
      formValid = _showError(
        signUpFormObj.passwordField,
        passwordError,
        "password-error",
        Messages.signUpErrors.passwordLength
      );
    } else {
      signUpFormObj.passwordField.classList.remove("error-border");
      signUpFormObj.passwordField.removeAttribute('aria-describedby');
      if (passwordError) {
        passwordError.remove();
      }
    }

    if (action === "/users") {
      //name
      if (signUpFormObj.nameField.value.trim().length < 3) {
        formValid = _showError(
          signUpFormObj.nameField,
          namerError,
          "name-error",
          Messages.signUpErrors.fullNameLength
        );
      } else {
        signUpFormObj.nameField.classList.remove("error-border");
        signUpFormObj.nameField.removeAttribute('aria-describedby');
        if (namerError) {
          namerError.remove();
        }
      }

      //terms and conditions
      if (!signUpFormObj.tncField.checked && formValid) {
        formValid = false;
        new bsAlert({
          alertType: "error",
          htmlMessage: true,
          text: Messages.signUpErrors.termsAndConditions
        });
      }
    }

    return formValid;
  }

  function _showError(fieldName, fieldError, errorName, errorMessage) {
    if (fieldError) {
      fieldError.remove();
    }
    fieldName.classList.remove("error-border");
    fieldName.insertAdjacentHTML(
      "afterend",
      '<div class="error-message" id="' +
        errorName +
        '"><div class="msg-body"><span>' +
        errorMessage +
        "</span></div></div>"
    );
    fieldName.classList.add("error-border");
    fieldName.setAttribute('aria-describedby', errorName);
  }

  function generate_url(appendRoute, subdomain) {
    var url = "https://";
    if (subdomain) {
      url += subdomain + ".";
    }
    url += window.location.hostname.replace(/^[^.]+\./g, "");
    if (appendRoute) {
      url += appendRoute;
    }
    return url;
  }

  function resetForm() {
    signUpFormObj.formObj.reset(); //Reset form
  }
})(csrf_token, signUpFormObj);

//check user email on blur event
signUpFormObj.emailField.addEventListener("blur", function(event) {
  var validEmail = true,
    that = this,
    action = signUpFormObj.formObj.getAttribute("action"),
    mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,8})+$/,
    emailError = document.getElementById("email-error"),
    emailFieldVal = that.value.trim();
    
  //set Csrf Token
  signUpForm.setCsrfToken();

  //clear error if exists
  that.classList.remove("error-border");
  that.removeAttribute('aria-describedby');
  if (emailError) {
    emailError.remove();
  }

  if (emailFieldVal == "" || !emailFieldVal.match(mailformat)) {
    var domain = emailFieldVal.substring(emailFieldVal.lastIndexOf("@") +1);

    if ( emailFieldVal.indexOf('@') === -1 
    || emailFieldVal.indexOf('.') === -1 
    || emailFieldVal.indexOf('..') !== -1 
    || bsLib.emailContainsNonLatinCharacters(emailFieldVal) 
    || !(emailFieldVal.indexOf('+') > -1 && (domain == 'browserstack.com' || domain == 'percy.io'))) {
      validEmail = signUpForm.showError(
        that,
        emailError,
        "email-error",
        Messages.emailValidationErrors.invalidEmail
      );
    }
  }

  //send ga event on blur of email field
  if (that.value.trim() !== '' && gaLoadedVal) {
    ga(bsGaDomain + '.send', "event", {eventCategory: "Microsoft Edge Form", eventAction: "InputText", eventLabel: "EmailField", eventValue: 0, hitCallback: null});
  }

  if (validEmail) {
    bsLib.ajax(
      "POST",
      railsHost + "/user/check_email",
      JSON.stringify({
        name: this.value.trim(),
        authenticity_token: csrf_token
      }),
      false,
      {
        "X-CSRF-Token": csrf_token,
        accept: "application/json",
        "content-type": "application/json; charset=utf-8" // Setting content type.
      },
      function(data) {
        var dataRequest = bsLib.JSONParse(data.response),
          nameElemt = signUpFormObj.formObj.querySelector(
            ".user-full-name-input-placeholder"
          ),
          tosElemt = signUpFormObj.formObj.querySelector(".checkout-tos"),
          submitElemt = document.getElementById("user_submit"),
          signOnElemt = signUpFormObj.signOn,
          fpElemt = signUpFormObj.forgotPassword;

        if (dataRequest.exists && action === "/users") {
          signUpFormObj.formObj.setAttribute("action", "/users/sign_in");

          //hide elements
          //name field
          if (nameElemt) {
            nameElemt.classList.remove("show");
            nameElemt.classList.add("hide");
          }

          //terms of services
          if (tosElemt) {
            tosElemt.classList.remove("show");
            tosElemt.classList.add("hide");
          }

          //update button value
          if (submitElemt) {
            submitElemt.setAttribute("value", "Sign me in");
          }

          //Forgot Password Link
          if (fpElemt) {
            fpElemt.classList.remove("hide");
            fpElemt.classList.add("show");
          }

          //google sign on button
          if (signOnElemt) {
            signOnElemt.lastElementChild.innerHTML = "Sign in with Google";
          }

          //show alert info for existing email
          if (sessionStorage.getItem("setSessionEmailExistKey") === null || sessionStorage.getItem("setSessionEmailExistKey") === 'false') {
            new bsAlert({
              alertType: "info",
              htmlMessage: true,
              text: 'Hooray! The email exists. Enter your password to start testing.'
            });
            sessionStorage.setItem("setSessionEmailExistKey", "true");
          }
        } else if (!dataRequest.exists && action === "/users/sign_in") {
          signUpFormObj.formObj.setAttribute("action", "/users");
          sessionStorage.setItem("setSessionEmailExistKey", "false");
          
          //show elements
          //name field
          if (nameElemt) {
            nameElemt.classList.remove("hide");
            nameElemt.classList.add("show");
          }

          //terms of services
          if (tosElemt) {
            tosElemt.classList.remove("hide");
            tosElemt.classList.add("show");
          }

          //Forgot Password Link
          if (fpElemt) {
            fpElemt.classList.remove("show");
            fpElemt.classList.add("hide");
          }

          //update button value
          if (submitElemt) {
            submitElemt.setAttribute("value", "Get unlimited Edge for free");
          }

          //google sign on button
          if (signOnElemt) {
            signOnElemt.lastElementChild.innerHTML = "Sign up with Google";
          }
        }
      },
      function() {},
      true
    );
  }
});

var recaptchaCallback = function() {
  return signUpForm.init(true);
};

//Reset captcha if expired
var expiredCaptchaCallback = function() {
  if (typeof grecaptcha !== "undefined") {
    grecaptcha.reset();
  }
};

//google button click
signUpFormObj.signOn.addEventListener("click", addTrackingEventsForGoogleBtn);

function addTrackingEventsForGoogleBtn() {
  var action = signUpFormObj.formObj.getAttribute("action");
  //Form interaction event
  if (action === "/users") {
    WebEventTracker.logEvent(EDS.webEvents, "ClickedSocialLogin", {
      form: "sso-sign-up",
      action: "click",
      success: "true",
      source: window.location.href,
      team: "wordpress"
    });
  } else {
    WebEventTracker.logEvent(EDS.webEvents, "ClickedSocialLogin", {
      form: "sso-sign-in",
      action: "click",
      success: "true",
      source: window.location.href,
      team: "wordpress"
    });
  }
}

//Sign up submit
signUpFormObj.formObj.addEventListener("submit", function(e) {
  e.preventDefault();
  var action = this.getAttribute("action");

  if (!signUpForm.validateFields()) {
    return false;
  }

  var recaptchaElemt = document.querySelectorAll(".g-recaptcha");
  for (var i = 0; i < recaptchaElemt.length; i++) {
    recaptchaElemt[i].classList.remove("error");
    if (recaptchaElemt[i].querySelector("span")) {
      recaptchaElemt[i].querySelector("span").remove();
    }
  }

  if (action === "/users") {
    if (typeof grecaptcha !== "undefined") {
      grecaptcha.execute();
    }
  } else {
    signUpForm.init(false);
  }

  return false;
});

//custom scroll to main form function
mainCtaBtnLinks.forEach(function(link) {
  link.addEventListener("click", scrollToMainForm);
});

function scrollToMainForm(e) {
  e.preventDefault();
  var offsetTop = document.querySelector('.microsoft-edge-form-section').offsetTop - 20;
    
  bsLib.scrollIt(
    offsetTop,
    1000
  );
}

function capitalizeLabelName(str) {
  var arr = str.trim().split(' ');
  arr.forEach(function(item, index) {
    arr[index] = item.replace(item[0], item[0].toUpperCase());
  });

  str = arr.join(' ');
  return str.replace(/\s+/g, '');
}

//check password field on blur event
signUpFormObj.passwordField.addEventListener("blur", function() {
  //send ga event on blur of email field
  if (signUpFormObj.passwordField.value.trim() !== '' && gaLoadedVal) {
    ga(bsGaDomain + '.send', "event", {eventCategory: "Microsoft Edge Form", eventAction: "InputText", eventLabel: "PasswordField", eventValue: 0, hitCallback: null});
  }
});

//check fullname field on blur event
signUpFormObj.nameField.addEventListener("blur", function() {
  //send ga event on blur of email field
  if (signUpFormObj.nameField.value.trim() !== '' && gaLoadedVal) {
    ga(bsGaDomain + '.send', "event", {eventCategory: "Microsoft Edge Form", eventAction: "InputText", eventLabel: "FullNameField", eventValue: 0, hitCallback: null});
  }
});
